// Translations for Telegram notifications, uplink alarm threshold and bulk coverage preview.
export const en = {
  "Włącz powiadomienia Telegram": "Enable Telegram notifications",
  "Token bota (ustawiony — puste = bez zmian)": "Bot token (set — empty = unchanged)",
  "Token bota (z @BotFather)": "Bot token (from @BotFather)",
  "Chat ID (przecinki dla wielu)": "Chat ID (comma-separated for multiple)",
  "Utwórz bota u @BotFather, wpisz token i Chat ID (np. z @userinfobot). Grupy: dodaj bota i użyj ujemnego ID grupy.":
    "Create a bot with @BotFather, enter the token and Chat ID (e.g. from @userinfobot). Groups: add the bot and use the negative group ID.",
  "Próg alarmu obciążenia uplinku (%)": "Uplink load alarm threshold (%)",
  "Alarm gdy wykorzystanie łącza przekroczy tę wartość.": "Alarm when link utilization exceeds this value.",
  "Powiększ wykres": "Enlarge chart",
  "Historia ruchu": "Traffic history",
  "Za mało danych w tym zakresie — zbieranie…": "Not enough data in this range — collecting…",
  "Podgląd adresów": "Address preview",
  "Odznacz adresy, których nie chcesz dodawać. Do utworzenia:": "Uncheck addresses you don't want to add. To create:",
  "Zaznacz wszystkie": "Select all",
  "Odznacz wszystkie": "Deselect all",
  "(bez ulicy)": "(no street)",
  "już istnieje": "already exists",
  "Wstecz": "Back",
};
export const de = {
  "Włącz powiadomienia Telegram": "Telegram-Benachrichtigungen aktivieren",
  "Token bota (ustawiony — puste = bez zmian)": "Bot-Token (gesetzt — leer = unverändert)",
  "Token bota (z @BotFather)": "Bot-Token (von @BotFather)",
  "Chat ID (przecinki dla wielu)": "Chat-ID (mit Komma für mehrere)",
  "Utwórz bota u @BotFather, wpisz token i Chat ID (np. z @userinfobot). Grupy: dodaj bota i użyj ujemnego ID grupy.":
    "Erstelle einen Bot mit @BotFather, gib Token und Chat-ID ein (z. B. von @userinfobot). Gruppen: Bot hinzufügen und negative Gruppen-ID verwenden.",
  "Próg alarmu obciążenia uplinku (%)": "Alarmschwelle Uplink-Auslastung (%)",
  "Alarm gdy wykorzystanie łącza przekroczy tę wartość.": "Alarm, wenn die Auslastung diesen Wert überschreitet.",
  "Powiększ wykres": "Diagramm vergrößern",
  "Historia ruchu": "Verkehrsverlauf",
  "Za mało danych w tym zakresie — zbieranie…": "Zu wenig Daten in diesem Bereich — Sammeln…",
  "Podgląd adresów": "Adressvorschau",
  "Odznacz adresy, których nie chcesz dodawać. Do utworzenia:": "Deaktivieren Sie Adressen, die Sie nicht hinzufügen möchten. Zu erstellen:",
  "Zaznacz wszystkie": "Alle auswählen",
  "Odznacz wszystkie": "Alle abwählen",
  "(bez ulicy)": "(ohne Straße)",
  "już istnieje": "existiert bereits",
  "Wstecz": "Zurück",
};
export const uk = {
  "Włącz powiadomienia Telegram": "Увімкнути сповіщення Telegram",
  "Token bota (ustawiony — puste = bez zmian)": "Токен бота (встановлено — порожнє = без змін)",
  "Token bota (z @BotFather)": "Токен бота (від @BotFather)",
  "Chat ID (przecinki dla wielu)": "Chat ID (через кому для кількох)",
  "Utwórz bota u @BotFather, wpisz token i Chat ID (np. z @userinfobot). Grupy: dodaj bota i użyj ujemnego ID grupy.":
    "Створіть бота через @BotFather, введіть токен і Chat ID (напр. з @userinfobot). Групи: додайте бота та використайте від'ємний ID групи.",
  "Próg alarmu obciążenia uplinku (%)": "Поріг тривоги завантаження uplink (%)",
  "Alarm gdy wykorzystanie łącza przekroczy tę wartość.": "Тривога, коли використання каналу перевищить це значення.",
  "Powiększ wykres": "Збільшити графік",
  "Historia ruchu": "Історія трафіку",
  "Za mało danych w tym zakresie — zbieranie…": "Недостатньо даних у цьому діапазоні — збирання…",
  "Podgląd adresów": "Попередній перегляд адрес",
  "Odznacz adresy, których nie chcesz dodawać. Do utworzenia:": "Зніміть позначки з адрес, які не хочете додавати. До створення:",
  "Zaznacz wszystkie": "Позначити всі",
  "Odznacz wszystkie": "Зняти всі позначки",
  "(bez ulicy)": "(без вулиці)",
  "już istnieje": "вже існує",
  "Wstecz": "Назад",
};
